import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageWrapper } from '../components/layout/PageWrapper';
import { ScoreTable } from '../components/scoreboard/ScoreTable';
import { useSeasons, useSeason } from '../hooks/useScoreboard';
import { Seo } from '../components/Seo';

export function ScoreboardPage() {
  const { t } = useTranslation('scoreboard');
  const { data: seasons, isLoading: seasonsLoading } = useSeasons();
  const currentSeason = seasons?.find((s) => s.isCurrent) ?? seasons?.[0];
  const [selectedSeasonId, setSelectedSeasonId] = useState<string>('');

  const activeSeason = selectedSeasonId || currentSeason?.seasonId || '';
  const { data: scores, isLoading: scoresLoading } = useSeason(activeSeason);

  return (
    <PageWrapper>
      <Seo title="Рейтинг игроков" description="Турнирная таблица и рейтинг игроков Queensland Mafia Club." path="/scoreboard" />
      <h1 className="text-4xl font-bold text-white mb-8">{t('title')}</h1>

      {seasonsLoading ? (
        <div className="flex justify-center py-20">
          <div className="w-8 h-8 border-2 border-mafia-accent border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <>
          {seasons && seasons.length > 1 && (
            <div className="flex gap-2 mb-6 flex-wrap">
              {seasons.map((s) => (
                <button
                  key={s.seasonId}
                  onClick={() => setSelectedSeasonId(s.seasonId)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    (selectedSeasonId || currentSeason?.seasonId) === s.seasonId
                      ? 'bg-mafia-accent text-white'
                      : 'bg-mafia-card text-gray-300 hover:text-white border border-gray-700'
                  }`}
                >
                  {s.name}
                  {s.isCurrent && (
                    <span className="ml-2 text-xs bg-white/20 px-1.5 py-0.5 rounded-full">
                      {t('current')}
                    </span>
                  )}
                </button>
              ))}
            </div>
          )}

          <div className="bg-mafia-card border border-gray-800 rounded-2xl overflow-hidden">
            {scoresLoading ? (
              <div className="flex justify-center py-12">
                <div className="w-8 h-8 border-2 border-mafia-accent border-t-transparent rounded-full animate-spin" />
              </div>
            ) : scores && scores.length > 0 ? (
              <ScoreTable scores={scores} />
            ) : (
              <p className="text-center text-gray-500 py-12">{t('empty')}</p>
            )}
          </div>
        </>
      )}
    </PageWrapper>
  );
}
